// extracted by mini-css-extract-plugin
export default {"container":"UnderConstruction__container___E8n8W","image":"UnderConstruction__image___ANSOx","title":"UnderConstruction__title___Sc9TG"};